import React from 'react';
import { V2SelectInput } from '@abyss/web/ui/SelectInput';
import { V2Text } from '@abyss/web/ui/Text';
import { V2TextInputArea } from '@abyss/web/ui/TextInputArea';
import { V2TextInput } from '@abyss/web/ui/TextInput';
import { V2DateInput } from '@abyss/web/ui/DateInput';
import { Grid } from '@abyss/web/ui/Grid';
import { DetailWrapper } from '@src/components/global/DetailWrapper';
import { ResponseDetailController } from './ResponseDetail.Controller';

export const ResponseDetail = () => {
  const { form, pageData, Action, pageTop, params, fieldsDisabled } =
    ResponseDetailController();
  return (
    <DetailWrapper
      data={pageData.detailResponse}
      form={form}
      formData={pageData.item}
      onSave={Action.Save}
    >
      <div ref={pageTop}>
        <Grid>
          <Grid.Col span={{ xs: 12, md: 5 }}>
            <Grid>
              <Grid.Col span={12}>
                <V2SelectInput
                  label="Technology"
                  placeholder="Select Technology"
                  isClearable={true}
                  isSearchable={true}
                  options={pageData.technologies}
                  model="technologyId"
                  isDisabled={fieldsDisabled}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2SelectInput
                  label="Theme"
                  placeholder="Select Theme"
                  isClearable={true}
                  isSearchable={true}
                  options={pageData.themes}
                  model="themeId"
                  isDisabled={fieldsDisabled}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2TextInputArea
                  label="Theme Notes"
                  model="themeNotes"
                  isDisabled={fieldsDisabled}
                  isClearable
                  onChange={(e) =>
                    form.setValue('themeNotes', e?.target?.value ?? '', {
                      shouldDirty: true,
                    })
                  }
                  css={{
                    'abyss-text-input-area-label': {
                      color: '#4b4d4f',
                      fontWeight: '500',
                    },
                  }}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2SelectInput
                  label="Action"
                  placeholder="Select Action"
                  isClearable={true}
                  isSearchable={true}
                  options={pageData.actions}
                  model="actionId"
                  isDisabled={fieldsDisabled}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2SelectInput
                  label="Action Owner"
                  placeholder="Select Action Owner"
                  isClearable={true}
                  isSearchable={true}
                  options={pageData.actionOwners}
                  model="actionOwnerId"
                  isDisabled={fieldsDisabled}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2TextInputArea
                  label="Action Notes"
                  model="actionNotes"
                  isDisabled={fieldsDisabled}
                  isClearable
                  onChange={(e) =>
                    form.setValue('actionNotes', e?.target?.value ?? '', {
                      shouldDirty: true,
                    })
                  }
                  css={{
                    'abyss-text-input-area-label': {
                      color: '#4b4d4f',
                      fontWeight: '500',
                    },
                  }}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2SelectInput
                  label="Assigned To"
                  placeholder="Select Assigned To"
                  isClearable={true}
                  isSearchable={true}
                  options={pageData.assignedTos}
                  model="assignedToId"
                  isDisabled={fieldsDisabled}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2DateInput
                  label="Follow Up Date"
                  model="followUpDate"
                  isClearable={false}
                  onChange={Action.OnDateChange}
                  isDisabled={fieldsDisabled}
                  css={{
                    'abyss-date-picker-input-label': {
                      color: '#4b4d4f',
                      fontWeight: '500',
                    },
                    'abyss-date-input-root': {
                      '.abyss-date-input-format-text': {
                        display: 'none',
                      },
                    },
                  }}
                />
              </Grid.Col>

              <Grid.Col span={12}>
                <V2SelectInput
                  label="Follow Up Status"
                  placeholder="Select Follow Up Status"
                  isClearable={true}
                  isSearchable={true}
                  options={pageData.followUpStatuses}
                  model="followUpStatusId"
                  isDisabled={fieldsDisabled}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2TextInputArea
                  label="Follow Up Response"
                  model="followUpMessage"
                  isDisabled={fieldsDisabled}
                  isClearable
                  onChange={(e) =>
                    form.setValue('followUpMessage', e?.target?.value ?? '', {
                      shouldDirty: true,
                    })
                  }
                  css={{
                    'abyss-text-input-area-label': {
                      color: '#4b4d4f',
                      fontWeight: '500',
                    },
                  }}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2TextInput
                  label="Region"
                  model="regionName"
                  isDisabled={true}
                />
              </Grid.Col>
            </Grid>
          </Grid.Col>
          <Grid.Col span={{ xs: 0, md: 1 }}></Grid.Col>
          <Grid.Col span={{ xs: 12, md: 6 }}>
            <V2Text
              color="$web.semantic.color.text.content.secondary"
              fontWeight="bold"
              css={{ marginBottom: '$md' }}
            >
              Survey Response
            </V2Text>
            <Grid css={{ marginTop: '$sm' }}>
              <Grid.Col span={12}>
                <V2Text fontWeight="bold" css={{ marginBottom: '$xs' }}>
                  Reflecting on your recent technology experience at
                  UnitedHealth Group, how satisfied are you with your overall
                  experience?
                </V2Text>
                <V2TextInput label="" model="question1" isDisabled />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2Text fontWeight="bold" css={{ marginBottom: '$xs' }}>
                  Have you encountered any challenges with our technology,
                  software, or applications that you have not chosen to report
                  in the past three months?
                </V2Text>
                <V2TextInput label="" model="question2" isDisabled />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2Text fontWeight="bold" css={{ marginBottom: '$xs' }}>
                  Do you feel your technology experience has improved, declined,
                  or remained consistent? Please explain why.
                </V2Text>
                <V2TextInput label="" model="question3" isDisabled />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2Text fontWeight="bold" css={{ marginBottom: '$xs' }}>
                  If you had an opportunity to share anything with your
                  technology partners, what would it be?
                </V2Text>
                <V2TextInput label="" model="question4" isDisabled />
              </Grid.Col>
              <Grid.Col span={12}>
                <V2Text fontWeight="bold" css={{ marginBottom: '$xs' }}>
                  Can a technology team member follow up with you regarding your
                  response?
                </V2Text>
                <V2TextInput label="" model="question5" isDisabled />
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </div>
    </DetailWrapper>
  );
};
